/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React, {memo, MouseEventHandler} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {toggleThemeStyle} from '../theme/helpers';
import {dlsColor, dlsTypography} from '../theme/theme';
import {CellMenuItem} from './CellMenuItem';

export interface HeaderButtonProps {
  icon?: JSX.Element;
  label: string;
  disabled?: boolean;
  onClick?: MouseEventHandler;
  showDisabledBulkTooltip?: boolean;
  menuPaddingTop?: string;
}

const useStyles = makeStyles(() => ({
  selectionsLabel : toggleThemeStyle({
    ...dlsTypography('selectionsLabel')
  }, {
    color         : dlsColor('white'),
    fontSize      : '12px',
    fontWeight    : 500,
    lineHeight    : '16px',
    fontFamily    : 'Inter',
    letterSpacing : '0px'
  })
}));

/**
 * Re-usable button for a grid header.
 *
 * ```typescript
 *
 *   import {HeaderButton} from '@ion/dls/src/grid/';
 *
 *   <HeaderButton onClick={onClick}
 *    icon={<MaterialMoreVertIcon />}
 *    label={translate(...)} />
 *
 * ```
 */
export const HeaderButton = ({
  onClick,
  icon,
  label,
  menuPaddingTop,
  disabled = false,
  showDisabledBulkTooltip = false
}: HeaderButtonProps) => {
  const classes = useStyles({showDisabledBulkTooltip});
  return (
    <CellMenuItem customStyles={{root: classes.selectionsLabel}}
      showDisabledBulkTooltip={showDisabledBulkTooltip}
      paddingTop={menuPaddingTop}
      onClick={onClick}
      disabled={disabled}
      icon={icon}
      label={label} />
  );
};

export default memo(HeaderButton);
